import './styles.css';
import { LayoutBuilder } from './LayoutBuilder';
import "./utlis/ArrrayPollyfills"
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.core.css';
export { LayoutBuilder };



(window as any).LayoutBuilder = LayoutBuilder;   